// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wsPjTrrD9OvSt1 {
  border-radius: 3px;
  box-sizing: border-box;
  display: inline-flex;
  overflow: hidden;
  padding: 6px 12px 6px 6px;
  position: relative;
  text-decoration: none;
}
.PjM51D4c0MB2Li {
  background: var(--ds-background-discovery, #f3f0ff);
}
.PjM51D4c0MB2Li:hover {
  background: var(--ds-background-discovery-hovered, #dfd8fd);
}
.PjM51D4c0MB2Li .PfhnMIaAFTApDU {
  background: var(--ds-background-discovery-bold, #6e5dc6);
}
.PjM51D4c0MB2Li .cZn1ZbuqMQs6re svg {
  color: var(--ds-icon-inverse, #ffffff);
}
.PjM51D4c0MB2Li .iGb_e2D2UnvFcg {
  color: var(--ds-text-subtle, #44546f);
}
.c_6vpyU51ONo8z {
  background: var(--ds-background-discovery-bold, #6e5dc6);
}
.c_6vpyU51ONo8z:hover {
  background: var(--ds-background-discovery-bold-hovered, #583f68);
}
.c_6vpyU51ONo8z:hover .cZn1ZbuqMQs6re svg {
  color: var(--ds-icon-discovery, #583f68);
}
.c_6vpyU51ONo8z .PfhnMIaAFTApDU {
  background: var(--ds-surface-raised, #ffffff);
}
.c_6vpyU51ONo8z .cZn1ZbuqMQs6re svg {
  color: var(--ds-icon-discovery, #8270db);
}
.c_6vpyU51ONo8z .iGb_e2D2UnvFcg {
  color: var(--ds-text-inverse, #ffffff);
}
.grC86gYZmPE2V4 {
  background: linear-gradient(97.78deg, var(--ds-background-accent-purple-bolder, #4423a3) 17.5%, var(--ds-background-accent-magenta-subtle, #aa63cb) 113.39%);
  margin: 0;
}
.grC86gYZmPE2V4:hover {
  background: linear-gradient(270deg, var(--ds-background-accent-purple-bolder, #403294) 0%, var(--ds-background-neutral-bold-pressed, #172b4d) 100%);
}
.grC86gYZmPE2V4 .cZn1ZbuqMQs6re svg {
  color: var(--ds-icon-inverse, #ffffff);
}
.grC86gYZmPE2V4 .iGb_e2D2UnvFcg {
  color: var(--ds-text-inverse, #ffffff);
}
.PfhnMIaAFTApDU {
  border-radius: 2px;
  height: 20px;
  margin-right: 8px;
  width: 20px;
}
.gz7n7E79VaS_VD {
  width: 100%;
  display: flex;
}
.p9irihHvATSgvL {
  justify-content: center;
}
.C7BvjmeiajOnPu {
  justify-content: left;
}
.cZn1ZbuqMQs6re {
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upgradePromptButton": `wsPjTrrD9OvSt1`,
	"upgradePromptButtonLightTheme": `PjM51D4c0MB2Li`,
	"upgradePromptButtonIconBackground": `PfhnMIaAFTApDU`,
	"upgradePromptButtonIcon": `cZn1ZbuqMQs6re`,
	"upgradePromptButtonCTA": `iGb_e2D2UnvFcg`,
	"upgradePromptButtonDarkTheme": `c_6vpyU51ONo8z`,
	"upgradePromptButtonGradientTheme": `grC86gYZmPE2V4`,
	"upgradePromptFitContainer": `gz7n7E79VaS_VD`,
	"upgradePromptJustifyCenter": `p9irihHvATSgvL`,
	"upgradePromptJustifyLeft": `C7BvjmeiajOnPu`
};
export default ___CSS_LOADER_EXPORT___;
